import { BookingStatus, BookingStatusMap } from "utils/interfaces"

export const STATUSES = {
    loading: "loading",
    loaded: "loaded",
    failure: "failure",
    try_again: "try_again",
}

export const BOOKING_STATUSES_CANCELLED = [
    BookingStatusMap.CANCELLED,
    BookingStatusMap.CANCELLED_AFTER_PAYMENT,
    BookingStatusMap.CANCELLED_WITHOUT_REFUND,
    BookingStatusMap.PAID_AFTER_CANCELLATION,
] as BookingStatus[]
